import { infiniteQueryOptions } from '@tanstack/react-query';
import { QueryKey } from '@/Config/api/queryKey';
import { ActionsApi } from '@/Domain/api/Action/ApiAction/Actions.api';

const PAGE_SIZE = 30;

type PageParam = { limit: number; offset: number };

export const useActionCalls = (actionId: number, onlyIssues: boolean, enabled: boolean) =>
  infiniteQueryOptions({
    queryKey: [QueryKey.actions.basic.calls, actionId, onlyIssues],
    queryFn: async ({ pageParam }) =>
      await ActionsApi.calls(actionId, { only_issues: onlyIssues, ...(pageParam as PageParam) }),
    getNextPageParam: (lastPage, pages) =>
      lastPage.has_more ? { limit: PAGE_SIZE, offset: pages.length * PAGE_SIZE } : undefined,
    initialPageParam: { limit: PAGE_SIZE, offset: 0 } as PageParam,
    enabled,
    staleTime: 0,
  });
